import axiosInstance from "./axiosInstance";
export interface SaveProfilePayload {
  displayName: string;
  emailAddress: string;
  itsNumber: string;
  mobileNo: string;
  whatsAppNumber: string;
}
export interface updatePasswordPayload {
  currentPassword: string,
  newPassword: string,
  confirmNewPassword: string
}

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getLoginUserDetails = async () => {
  const res = await axiosInstance.get("/Auth/me", {
    headers: getAuthHeader(),
  });
  return res.data;
};

export const updateProfile = async (payload: SaveProfilePayload) => {
  try {
    const response = await axiosInstance.put("/profile", payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const updatePassword = async (payload: updatePasswordPayload) => {
  try {
    const response = await axiosInstance.put("/profile/change-password", payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
